<template lang="pug">
  div
    doc-markdown(source=`
    ## Checkbox \`sw-checkbox\`
    Our checkbox components are by default bound to boolean data attributes and work standalone.<br>
    To group multiple checkboxes together, see our <a href="/documentation/vue-generic-components/checkbox-group">sw-checkbox-group</a> wrapper component.
    `)

    doc-preview(vue=`
    sw-checkbox(
      v-model="booleanValue"
      custom-classes='flex max-w-xs rounded border border-green-200 py-3 my-3'
      checkbox-classes='w-6 h-6 p-3 mx-3 rounded-sm border flex items-center justify-center'
      checked-checkbox-classes='text-blue-500'
    )
      span(v-text="'Boolean Value'")
      sw-icon(name='check' size='w-8 h-8' slot='checkedIcon')

    <script>
      ...
      data() {
        return {
          booleanValue: false,
        }
      }
    </script>
    `)
      sw-checkbox(
        v-model="booleanValue"
        custom-classes="flex max-w-xs rounded border border-green-200 py-3 my-3"
        checkbox-classes="w-6 h-6 p-3 mx-3 rounded-sm border flex items-center justify-center"
        checked-checkbox-classes="text-blue-500"
      )
        span(v-text="'Boolean Value'")
        sw-icon(name='check' size="w-8 h-8" slot='checkedIcon')

    doc-markdown(source=`
    ### Slots
  | Slot name      | Description                                                                   |
  |----------------|-------------------------------------------------------------------------------|
  | *default*      | The label                                                                     |
  | \`checkedIcon\`| The optional icon that can be injected when a checkbox item is checked.       |
    `)

    doc-markdown(source=`
    ### Properties
  | Props                       | Description                                                           | Type   | Default |
  |-----------------------------|-----------------------------------------------------------------------|--------|---------|
  | \`value\`  (v-model)        | Boolean value that will be affected by the input.                     | Boolean| false   |
  | \`checkbox-value\`          | Value of specific checkbox item (needed for grouped checkboxes).      | String | -       |
  | \`custom-classes\`          | Classes wrapping the whole component.                                 | String | -       |
  | \`checkbox-classes\`        | Classes applied on the check-"box" part of the component.             | String | -       |
  | \`checked-checkbox-classes\`| Classes applied on the check-"box" part of the component when checked.| String | -       |
    `)

    doc-markdown(id="events" source=`
    ### Events
  | Event name | Description                                                            | Parameters                 | Usage      |
  |------------|------------------------------------------------------------------------|:--------------------------:|------------|
  | input      | Triggered when clicked if element is not part of a \`SwCheckboxGroup\` | boolean, reverse of value  | \`@input\` |
    `)

    doc-markdown(source=`
    ### Injects
    When multiple checkboxes are bound to one group (via the use of \`SwCheckboxGroup\` wrapping component), the array of checked checkbox values is injected here, as well as a function allowing this component to update this array.
  | name                         | Description                                                | default |
  |------------------------------|------------------------------------------------------------|---------|
  | checkboxGroupValueArray      | Array of selected values in SwCheckboxGroup parent element | null    |
  | updateCheckboxGroupValueArray| Function to update the checkboxGroupValueArray in the parent element                | null    |
    `)
</template>

<script>
  export default {
    data () {
      return {
        booleanValue: false,
      };
    },
  };
</script>
